import { render, staticRenderFns } from "./EmSavingState.vue?vue&type=template&id=2bdb05d7&scoped=true&"
import script from "./EmSavingState.vue?vue&type=script&lang=js&"
export * from "./EmSavingState.vue?vue&type=script&lang=js&"
import style0 from "./EmSavingState.vue?vue&type=style&index=0&id=2bdb05d7&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bdb05d7",
  null
  
)

export default component.exports